const MWBaseUrl = process.env.REACT_APP_MW_BASE_URL || '';
const WSBaseUrl = process.env.REACT_APP_WS_URL || '';

export default {
  signIn: '/api/login',
  rcsInit: '/api/rcs-init',
  getSL: '/api/links/shorten',
  MWGetAccount: `/api/me`,
  MWGetBalance: `${MWBaseUrl}/users/me/balance`,
  getWS: (apiBaseURL) => `${WSBaseUrl || apiBaseURL}/hub`,
  processLinks: '/api/links/tokens',
  linksLength: '/api/links/longest',
  processKeywordEvents: '/api/keyword_events',
  validateTelegramBot: '/api/agents/telegram/validate-bot',
  setWebhookTelegram: '/api/agents/telegram/set-webhook',
  updateTokenTelegram: '/api/agents/telegram/update-token',
  processFile: '/api/media',
  customers: '/api/customers',
  whatsapp: '/api/agents/whatsapp',
  featureFlags: '/flags',
  messages: '/api/messages',
  channels: '/api/channels',
  conversations: '/api/conversations',
  templates: '/api/templates',
  permissions: '/api/permissions',
  settings: '/api/settings',
  scenarios: '/api/scenarios',
};
